import { Auth, Hub } from 'aws-amplify';
import { validateSession } from './authService';

const makeInStoreHeaders = async () => {
  const isValid = await validateSession();
  if (isValid){
    const token = await localStorage.getItem('token');
    return {
      Authorization: token,
      'Content-Type': 'application/json'
    };
  } 
  Hub.dispatch('storeAuth', {event: 'expired'})
}

const makeCognitoHeaders = async () => {
  try {//check user is still valid and refresh token if yes
    const user = await Auth.currentAuthenticatedUser();
    const sesh = user.signInUserSession;
    user.refreshSession(sesh.refreshToken, () => {})
    const accessToken = await (await Auth.currentSession()).getAccessToken().getJwtToken();
    return {
      Authorization: accessToken,
      'Content-Type': 'application/json'
    };
  } catch(error){
    console.log(error)
    Auth.signOut();
  }
}

const makeHeaders = async() => {
  const isInStore = await localStorage.getItem('isInStore');
  const headers = (await isInStore)? makeInStoreHeaders(): makeCognitoHeaders();
  return headers
};

export default makeHeaders;